<template>
  <base-list-item class="scs-note-item">
    <p class="note-body">{{ note.body }}</p>
    <div class="icons">
      <round-button-with-icon
        class="icon"
        :icon="note.public ? 'eye-open' : 'eye-strike'"
        @click="toggleVisibility"
      />
      <round-button-with-icon
        class="icon"
        :icon="deleting ? 'spinner' : 'trash-can'"
        @click="deleteNote"
      />
    </div>
    <p class="note-date">
      {{ formatDate(note.date) }}
    </p>
  </base-list-item>
</template>
<script>
import { formatDate } from "../../../../Helpers/invoice.js";
import BaseListItem from "../BaseListItem.vue";

import RoundButtonWithIcon from "../../RoundButtonWithIcon.vue";

export default {
  data() {
    return {
      deleting: false,
    };
  },
  computed: {},
  methods: {
    formatDate,
    deleteNote() {
      this.deleting = true;
      this.$emit("delete-note");
    },
    toggleVisibility() {
      this.$emit("toggle-visibility");
    },
  },
  created() {},
  components: {
    BaseListItem,
    RoundButtonWithIcon,
  },
  emits: ["delete-note", "toggle-visibility"],
  props: ["note"],
};
</script>
<style scoped>
.scs-note-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  margin: 0 0 30px 0;
}

p {
  font-size: 0.7rem;
  text-align: left;
  font-weight: 600;
}

.icons {
  display: flex;
  justify-self: right;
}

.note-date {
  position: absolute;
  top: calc(100% - 0.7rem + 2px);
}
</style>
